var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('usage-bar',{attrs:{"usage":_vm.usage}},[_c('span',{staticClass:"usage-text"},[_vm._v(_vm._s(_vm.usageLine))])])}
var staticRenderFns = []

export { render, staticRenderFns }